import axios from '@/jslib/axios'
import {productAPiPath} from '@/utils/smePath'

export const getSMEOption =  (params, product_id = 81) => {
  return axios({
    method: 'get',
    url: `/admin/option/sme/${productAPiPath[product_id]}`,
    params
  })
}
export const SMEQuickQuote =  (data, product_id = 81) => {
  return axios({
    method: 'post',
    url: `/admin/quote/sme/${productAPiPath[product_id]}`,
    data
  })
}
export const SMEBuyPolicy =  (data, product_id = 81) => {
  return axios({
    method: 'post',
    url: `/admin/order/sme/${productAPiPath[product_id]}/buy`,
    data
  })
}
export const getSMEPolicyDetail =  (params, product_id = 81) => {
  return axios({
    method: 'get',
    url: product_id==80?'/admin/order/sme/policy/detail':`/admin/order/sme/${productAPiPath[product_id]}/policy/detail`,
    params
  })
}
export const getSMEQuoteDetail =  (params, product_id = 81) => {
  return axios({
    method: 'get',
    url: product_id==80?'/admin/order/sme/quote/detail':`/admin/order/sme/${productAPiPath[product_id]}/quote/detail`,
    params
  })
}
export const saveSMEKyc =  (data, product_id = 81) => {
  return axios({
    method: 'post',
    url: `/admin/order/sme/${productAPiPath[product_id]}/save`,
    data
  })
}
export const applySMEDiscount =  data => {
  return axios({
    method: 'post',
    url: '/admin/order/sme/discount/apply',
    data
  })
}
export const addSMERefer =  (data, product_id = 81) => {
  return axios({
    method: 'post',
    url: `/admin/quote/sme/${productAPiPath[product_id]}/refer/add`,
    data
  })
}
export const addSMEReferTransform =  (data, product_id = 81) => {
  return axios({
    method: 'post',
    url: `/admin/order/sme/${productAPiPath[product_id]}/refer/transform`,
    data
  })
}
export const downloadSMEPdf =  (params, product_id = 81) => {
  return axios({
    method: 'get',
    url: '/admin/order/sme/download/indicative',
    responseType: 'blob',
    params
  })
}
export const downloadSMEPdfDiret =  (data, product_id = 81) => {
  return axios({
    method: 'post',
    url: `/admin/sme/${productAPiPath[product_id]}/download/indicative/direct`,
    responseType: 'blob',
    data
  })
}
export const editSMEQuoteResult =  (data, product_id = 81) => {
  return axios({
    method: 'post',
    url: `/admin/sme/${productAPiPath[product_id]}/quote/edit/result`,
    data
  })
}
export const getSMEReferDetail =  (params, product_id = 81) => {
  return axios({
    method: 'get',
    url: product_id==80?'/admin/order/sme/refer/detail':`/admin/order/sme/${productAPiPath[product_id]}/refer/detail`,
    params
  })
}
export const getSMEPremiumData =  (params) => {
  return axios({
    method: 'get',
    url: '/admin/order/sme/premium/table',
    params
  })
}
export const getSMEReferRemark =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/referral/remark/add',
    data
  })
}
export const getSMEReferMain =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/order/sme/order/main',
    data
  })
}
export const replySMERefer =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/order/sme/refer/reply',
    data
  })
}
export const delSMEReferQuote =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/order/sme/refer/del',
    data
  })
}
export const smeIssuing =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/order/sme/issuing',
    data
  })
}
